import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import React from "react";


const InfoTooltip = ({message}) => {
    return <Tooltip title={<div style={{whiteSpace: "pre-line"}}>{message}</div>} placement="top" arrow sx={{whiteSpace: 'pre'}}>
        <Icon color='info'>info</Icon>
    </Tooltip>
}

const WithInfoTooltip = ({children, message}) => {
    return <div style={{display: 'flex', alignItems: 'center', columnGap: 8}}>
        {children}
        <InfoTooltip message={message}/>
    </div>
}

export default WithInfoTooltip;